import { useStrictLocalization } from "@faire/web--source/common/localization";

export const useHeaderSignUpCopy = () => {
  const { strictLocalize } = useStrictLocalization();
  return strictLocalize({
    defaultMessage: "Sign up",
    description: { text: "CTA button to sign up" },
  });
};
